import { modifier } from 'ember-modifier';

// If the callback returns a function, it will be called when the element is destroyed
export default modifier(
  (
    element: HTMLInputElement,
    [callback]: [(element: HTMLInputElement) => () => void | void],
  ) => {
    return callback(element);
  },
);
